import React, { useState, useEffect } from 'react';
import SnackbarContentWrapper from 'components/molecules/Snackbar/SnackbarContentWrapper';

import { makeStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
const useStyles = makeStyles((theme) => ({
  snackbarRoot: {
    zIndex: theme.zIndex.snackbar,
    marginTop: 50,
    padding: '10px 25px',
  },
}));

const SnackbarWrap = (props) => {
  const {
    open = false,
    anchorOrigin = {
      vertical: 'top',
      horizontal: 'center',
    },
    autoHideDuration = 3000,
    onClose = (f) => f,
    variant = '',
    message = '',
  } = props;
  const classes = useStyles();

  const [openFleg, setOpenFleg] = useState(false);

  useEffect(() => {
    setOpenFleg(open);
  }, [open]);

  return typeof message !== 'undefined' ? (
    <Snackbar
      anchorOrigin={anchorOrigin}
      open={openFleg}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      classes={{
        root: classes.snackbarRoot,
      }}
    >
      <SnackbarContentWrapper variant={variant} message={message} />
    </Snackbar>
  ) : null;
};

export default SnackbarWrap;
